<div class="ec-weather-forecast-container">
    <div fxLayout="row" fxLayoutAlign="start center" class="ec-weather-forecast-time-panel">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
            <div class="txt-s-16-4">
                {{'Time range'|i18n}}:
            </div>
            <div>
                <app-time-filter #timeFilter
                                 [profile]="TimeFilterProfile.FORECAST_MEASURES"
                                 [defaultType]="DEFAULT_TIME_FILTER"
                                 (timeFilterChange)="onSelectTimeFilter($event)">
                </app-time-filter>
            </div>
        </div>
        <mat-divider vertical class="time-divider"></mat-divider>
        <mat-radio-group fxLayout="row" fxLayoutGap="1rem" color="primary" [(ngModel)]="mode">
            <mat-radio-button [value]="ForecastMeasureMode.SINGLE">{{'Most recent values'|i18n}}</mat-radio-button>
            <mat-radio-button [value]="ForecastMeasureMode.MULTIPLE">{{'All values'|i18n}}</mat-radio-button>
        </mat-radio-group>
    </div>
    <div fxLayout="column" class="ec-weather-forecast-main-panel mt-32">
        <div fxLayout="row wrap" fxLayoutGap="28px" class="ml-16 mt-36 mb-42 options-row">
            <div *ngIf="!options.length" fxLayout="row" fxLayoutAlign="center">
                {{'No measures available'|i18n}}
            </div>
            <div *ngFor="let option of options" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                <mat-checkbox app-checkbox class="txt-p-14-4"
                              [checked]="isOptionSelected(option)"
                              (change)="onSelectOption(option, $event.checked)">
                </mat-checkbox>
                <div class="txt-p-14-4">{{option.name|i18n}}</div>
            </div>
        </div>
        <div cdkDropList cdkDropListLockAxis="y" cdkDropListOrientation="vertical"
             class="measure-charts" (cdkDropListDropped)="onMeasureDrop($event)">
            <div cdkDrag *ngFor="let meas of measures; let first=first let last=last" class="measure-box"
                 [ngClass]="{'mt-16': !first, 'mb-52': last}">
                <div *appVar="meas.data|async as measData"
                     fxLayout="column" fxLayoutAlign="start stretch" class="measure">
                    <div cdkDragHandle fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="32px"
                         fxFlexAlign="start" class="measure-name mb-24">
                        <div class="txt-h-18-7">{{meas.name|i18n}}</div>
                    </div>
                    <div *ngIf="!!measData && !!measData.data.length" class="measure-chart">
                        <app-line-chart
                                [data]="mode === ForecastMeasureMode.SINGLE ? [measData.data[0]] : measData.data"
                                [margins]="{left: 65, right: -20, top: 10, bottom: 35}"
                                [yTickFormatter]="measData.uom|yTickFormatter"
                                [tooltipFormatter]="measData.uom|tooltipFormatter:TIME_DELTA_QUARTER_HOUR"
                                [xGrid]="true"
                                [yGrid]="true"
                                [gridColor]="gridColor"
                                [tooltipBorderColor]="tooltipBorderColor"
                                [tooltipBackgroundColor]="tooltipBackgroundColor"
                                [selectionLineColor]="selectionLineColor"
                                [xTickSpace]="80"
                                [yTickSpace]="30"
                                [enableZoom]="true"
                                [enableSelection]="true"
                                (selection)="onSelectTimeRangeFromChart($event)"
                                [resizeTrigger]="contentResize">
                        </app-line-chart>
                    </div>
                    <div *ngIf="!!measData && !measData.data.length" fxLayout="row" fxLayoutAlign="center center">
                        <app-icon name="fal-exclamation-circle"></app-icon>&nbsp;
                        <span class="pl-8">{{'No data'|i18n}}</span>
                    </div>
                    <div *ngIf="!measData" fxLayout="row" fxLayoutAlign="center" class="measure-loading">
                        <mat-spinner diameter="20"></mat-spinner>
                        <span class="pl-8">{{'Loading data'|i18n}}...</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
